module.exports = __webpack_public_path__ + "img/pic_start_supersale1@2x.b7dcf99f.png";